import styled from 'styled-components';
import { Button as AntButton } from 'antd';

export const ModalContainer = styled.div`
  padding: 10px 20px 30px 20px;
  min-height: 420px;
`;

export const TableText = styled.span`
  font-size: 14px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: right;
  margin-top: 40px;
  gap: 10px;
`;

export const UpdateButton = styled(AntButton)`
  min-width: 100px;
  height: 35px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
`;

export const FormBox = styled.div`
  border: 2px solid #d8e0e8;
  padding: 40px 50px;
  max-width: 650px;
  margin: 0 auto;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  row-gap: 22px;
  column-gap: 20px;
  align-items: center;
`;

export const FormGridWide = styled.div`
  display: grid;
  grid-template-columns: 220px 1fr;
  row-gap: 22px;
  column-gap: 30px;
  align-items: center;
`;

export const Label = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #2f3b4a;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 150px;
  border: 2px solid #d8e0e8;
  border-radius: 6px;
  padding: 18px 16px;
  font-size: 16px;
  resize: vertical;
  outline: none;
`;

export const FooterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const ConditionRow = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  align-items: center;
  column-gap: 10px;
  margin-bottom: 25px;
`;

export const CommentsLabel = styled.div`
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #2f3b4a;
`;
